import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from './../../services/snackbar.service';
import { DailyLogService } from '../daily-log.service';
import { BehaviorSubject, finalize, Subject, takeUntil } from 'rxjs';
import { CaptureMediaComponent } from '../capture-media/capture-media.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from './../../services/common.service';

@Component({
  selector: 'app-view-daily-log',
  templateUrl: './view-daily-log.component.html',
  styleUrls: ['./view-daily-log.component.scss']
})
export class ViewDailyLogComponent implements OnInit {
  formDailyLog: FormGroup;
  projectId: any;
  projectDetail: any;

  @ViewChild('fileInput') fileInput;
  @ViewChild('fileInput2') fileInput2;
  @ViewChild("logtitleInput", { static: false }) logtitleInput;
  @ViewChild("logdetailInput", { static: false }) logdetailInput;

  latitude: number;
  longitude: number;
  filesList: File[] = [];
  ngUnsubscribe = new Subject();
  showToContractor: boolean = false;
  showToCustomer: boolean = false;
  filesSubj = new BehaviorSubject<File[]>(null);
  loadingSubject = new BehaviorSubject<boolean>(false);
  contractorList: any = [];
  user_id: string = '';
  isFranchisee:boolean=false;
  today: Date = new Date(); 
      weather_icons=[
      {
        weather: "Clear Sky",
        icon: "01d"
      },
      {
        weather: "Few Clouds",
        icon: "02d"
      },
      {
        weather: "Scattered Clouds",
        icon: "03d"
      },
      {
        weather: "Broken Clouds",
        icon: "04d"
      },
      {
        weather: "Shower Rain",
        icon: "09d"
      },
      {
        weather: "Rain",
        icon: "10d"
      },
      {
        weather: "Thunderstorm",
        icon: "11d"
      },
      {
        weather: "Snow",
        icon: "13d"
      },
      {
        weather: "Mist",
        icon: "50d"
      }
    ];
    selectedWeatherIndex:number;
    selectedWeatherIcon:string;
    selectedWeather:string;
  constructor(private fb: FormBuilder, private dlService: DailyLogService, private router: Router,
    private route: ActivatedRoute, public snackbarService: SnackbarService, public dialog: MatDialog,
    private commonService:CommonService) { }

  ngOnInit(): void {
    navigator.geolocation.getCurrentPosition(res => {
      this.latitude = res?.coords?.latitude
      this.longitude = res?.coords?.longitude
      // this.projectId = this.route.snapshot.paramMap.get('id');
      this.route.queryParams.subscribe((query:any)=>{
        this.projectId=query?.projectId
      })
      // console.log(this.projectId);
      // console.log(this.latitude);
      // console.log(this.longitude);
    })
    this.projectDetail = JSON.parse(sessionStorage.getItem('project_detail'));
    this.buildFormDailyLog();
    this.isFranchisee=this.commonService.isFranchisee;
  }
  buildFormDailyLog() {
    // let storedArray=JSON.parse(sessionStorage.getItem('fileList'));
    // for(let file of storedArray){}
    if (sessionStorage.getItem('fileList') && sessionStorage.getItem('fileList') !== undefined) {
      this.formDailyLog = this.fb.group({
        daily_log_id: [0],
        log_title: ['', [Validators.required,Validators.maxLength(200)]],
        log_description: ["",Validators.maxLength(1000)],
        daily_log_uploads_document: this.fb.array(JSON.parse(sessionStorage.getItem('fileList'))),
        daily_log_uploads: this.fb.array([]),
        date_related_exists:[false],
        date_related:['']
      });
    }
    else {
      this.formDailyLog = this.fb.group({
        daily_log_id: [0],
        log_title: ['', [Validators.required,Validators.maxLength(200)]],
        log_description: ["",Validators.maxLength(1000)],
        daily_log_uploads_document: this.fb.array([]),
        daily_log_uploads: this.fb.array([]),
        date_related_exists:[false],
        date_related:['']
      });
    }
    // if (sessionStorage.getItem('fileList') && sessionStorage.getItem('fileList') !== undefined) {
    //   // let control=this.formDailyLog.get('daily_log_uploads_document') as FormArray;
    //   // control.push(JSON.parse(sessionStorage.getItem('fileList')))
    //   this.formDailyLog.patchValue({
    //     daily_log_uploads_document:this.fb.array(JSON.parse(sessionStorage.getItem('fileList')))
    //   })
    //   console.log(this.formDailyLog);
    //   // let control = this.formDailyLog?.get('daily_log_uploads_document') as FormArray;
    //   // control?.push(sessionStorage.getItem('fileList'));
    // }
    // console.log(this.formDailyLog.get('daily_log_uploads_document').value);
  } 

  //Old code starts
  // buildFormDailyLog() {
  //   let userdata = JSON.parse(sessionStorage.getItem('userdata'))
  //   this.formDailyLog = this.fb.group({
  //     subcontractor_id: [userdata.subcontractor_id],
  //     daily_log_id: [0],
  //     log_title: ['', [Validators.required]],
  //     log_description: [""],
  //     daily_log_uploads_document: this.fb.array([]),
  //     // projectId: [this.projectId],
  //     daily_log_uploads: this.fb.array([])
  //   });
  // }
  // saveFormDailyLog() {
  //   this.formDailyLog.markAsTouched();
  //   if (!this.formDailyLog.invalid) {
  //     let request = JSON.stringify(this.formDailyLog.value);
  //     request = JSON.parse(request);
  //     request['daily_log_uploads'] = request['daily_log_uploads'].concat(request['daily_log_uploads_document']);
  //     delete request['daily_log_uploads_document'];
      
  //     request['project_id'] =this.projectId; 
  //     request['weather_location'] = {
  //       latitude: this.latitude,
  //       longitude: this.longitude,
  //     }
  //     this.dlService.saveDailyLog(request).subscribe(data => {
  //       if (data['status'] == 200 && data['message']) {
  //         this.openSnackbar(data['message']);
  //         this.router.navigate(['/project/daily-logs'],{queryParams:{
  //           id:this.projectId
  //         }})
  //       }
  //     }, error => {
  //       console.log(error);
  //     })
  //   }
  // }

  // pushFileData(data, type) {
  //   console.log(data)
  //   let control = this.formDailyLog.get('daily_log_uploads_document') as FormArray;
  //   control.push(this.fb.group({
  //     file_path: [data.file_path],
  //     file_name: [data.file_original_name],
  //     file_id: [data.fileId],
  //     daily_log_upload_type: [type],
  //   }));
  //   this.fileInput.nativeElement.value = '';

  // }

  // uploadFile(file, type) {
  //   const formData = new FormData();
  //   formData.append('myFile', file);
  //   this.dlService.fileUpload(formData).pipe().subscribe(data => {
  //     console.log(data)
  //     if (data['status'] == 200) {
  //       this.pushFileData(data['data'], type)
  //       this.openSnackbar(data['data']['message']);
  //     } else this.openSnackbar(data['message']);
  //   }, error => {
  //     console.log(error);
  //   })
  // }

  // onFileChange(event) {
  //   const file: File = event.target.files[0];
  //   console.log(file)
  //   if ((file.type != 'image/jpeg') && (file.type != 'image/jpg') && (file.type != 'application/pdf') && (file.type != "image/png")) {
  //     this.openSnackbar('Only jpg, jpeg, png, pdf file can be uploaded');
  //     return
  //   }
  //   let filetype
  //   if ((file.type == 'image/jpeg') || (file.type == 'image/jpg') || (file.type == "image/png")) {
  //     filetype = 'photo';
  //     this.uploadFile(file, filetype);
  //   } else {
  //     filetype = 'documents';
  //     this.uploadFile(file, filetype);
  //   }
  // }

  // removeFile(index, type) {
  //   if (type == 'document') {
  //     let control = this.formDailyLog.get('daily_log_uploads_document') as FormArray;
  //     control.removeAt(index);
  //   } else {
  //     let control = this.formDailyLog.get('daily_log_uploads') as FormArray;
  //     control.removeAt(index);
  //   }
  // }

  /**
* open toaster for showing message 
*/
//old code ends



//new code starts
onFileChange(event) {
  const target = event?.target;
  let targetedFiles = target?.files;
  console.log(targetedFiles?.length);
  for (let file of Array.from(targetedFiles)) {
    console.log(file);
    if (this.formDailyLog.get('daily_log_uploads_document').value?.map(el => el['fileName']).includes(file['name'])) {
      // console.log('same here');
      this.openSnackbar(`A file naming "${file['name']}" is already uploaded. Please change the name of the file to upload, if uploaded not by mistake`);
      this.removeFileFromInput(file['name'])
      // console.log(this.filesList);
    }
  }
  if ((JSON.parse(sessionStorage.getItem('fileList'))?.length + targetedFiles?.length) > 10) {
    this.openSnackbar('Maximum 10 files are allowed to upload');
    for (let file of Array.from(targetedFiles)) {
      this.removeFileFromInput(file['name'])
    }
    return
  };
  console.log(event);
  const files: File[] = event.target?.files;
  let fileArray: File[] = [];
  if (!files) return;

  let filesProcessed = 0;

  for (let file of files) {
    const fileReader = new FileReader(); // Create a new FileReader for each file

    fileReader.onloadend = async (e) => {
      const arrayBuffer = e.target.result as ArrayBuffer;
      // const uint8Array = new Uint8Array(arrayBuffer);
      try {
        const fileType = await this.getFileType(arrayBuffer);
        if (fileType != 'unknown' && file?.type !== fileType) {
          this.openSnackbar(`${file?.name} is corrupted`);
          this.removeFileFromInput(file?.name);
          return;
        }
        console.log(fileType);
        if (!fileType || (
          fileType !== 'image/jpeg' &&
          fileType !== 'application/pdf' &&
          fileType !== 'image/png' &&
          fileType !== 'video/mp4'
          // fileType !== 'application/msword' &&
          // fileType !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' &&
          // fileType !== 'text/plain'
        )) {
          this.openSnackbar(`${file?.name} is not a valid format. Only PNG, JPG, PDF and MP4 files are allowed.`);
          return;
        }
        fileArray.push(file);
        this.filesSubj.next(fileArray);
      } catch (error) {
        console.error('Error parsing file type:', error);
        this.openSnackbar('Error validating file. Please try again.');
      } finally {
        filesProcessed++;
        if (filesProcessed === files.length) {
          // All files have been processed
          console.log('All files have been processed');
          console.log('Final fileArray:', fileArray);

          // this.filesList?.push(...fileArray)
          let sessionArray = [];
          for (let file of fileArray) {
            this.filesList?.push(file)
          }
          sessionArray = fileArray.map(el => {
            return {
              lastModified: el?.lastModified,
              lastModifiedDate: new Date(el['lastModifiedDate']),
              name: el?.name,
              size: el?.size,
              type: el?.type,
              webkitRelativePath: el?.webkitRelativePath,
            }
          })
          console.log(sessionArray);
          console.log(fileArray);
          console.log(this.filesList);
          console.log(JSON.parse(sessionStorage.getItem('fileList')));
          this.uploadFiles(fileArray)
        }
      }
    };

    fileReader.readAsArrayBuffer(file); // Start reading the file
  }
}
async getFileType(arrayBuffer) {
  const magicNumbers = {
    'ffd8ffe0': 'image/jpeg',
    'ffd8ffe1': 'image/jpeg',
    'ffd8ffe2': 'image/jpeg',
    '89504e47': 'image/png',
    '25504446': 'application/pdf',
    // 'd0cf11e0': 'application/msword', // DOC files
    // '504b0304': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // DOCX files
    '66747970': 'video/mp4', // MP4 files (generic video type)
    '00000018': 'video/mp4', // MP4 files (ftyp)
    '00000020': 'video/mp4', // MP4 files (moov)
    '6D6F6F76': 'video/mp4', // MP4 files (moov)
    '00000021': 'video/mp4', // MP4 files (mdat)
    '0000001C': 'video/mp4', // MP4 files (mvhd)
    // '75737461': 'text/plain', // Plain text files (ASCII text)
    // Add more magic numbers and their corresponding file types here
  };

  const bytes = new Uint8Array(arrayBuffer).subarray(0, 4);
  let header = '';
  for (let i = 0; i < bytes.length; i++) {
    header += bytes[i].toString(16).padStart(2, '0');
  }

  return magicNumbers[header] || 'unknown';
}
removeFileFromInput(name: string) {
  // const fileInput = document.getElementById('fileInput');
  const files = this.fileInput.nativeElement.files;

  // Convert FileList to an array
  let fileArray = Array.from(files);

  // Specify the name of the file to be removed
  const fileNameToRemove = name;

  // Filter the array to exclude the file to be removed
  fileArray = fileArray.filter(file => file['name'] !== fileNameToRemove);

  // Create a new DataTransfer object
  const dataTransfer = new DataTransfer();

  // Append the remaining files to the DataTransfer object
  fileArray.forEach((file: File) => dataTransfer.items.add(file));

  // Assign the new FileList to the input element
  this.fileInput.nativeElement.files = dataTransfer.files;

  // For demonstration purposes, log the remaining files
  console.log(this.fileInput.files);
}

// onFileChange(event) {
//   const files: File[] = event.target.files;
//   console.log(files);
//   let filesArray = [];
//   for (let file of Array.from(files)) {
//     if ((file.type != 'image/jpeg') && (file.type != 'image/jpg') && (file.type != 'application/pdf') && (file.type != "image/png")) {
//       this.openSnackbar('Only jpg, jpeg, png, pdf file can be uploaded');
//       return
//     }
//     let filetype
//     if ((file.type == 'image/jpeg') || (file.type == 'image/jpg') || (file.type == "image/png")) {
//       filetype = 'photo';
//       filesArray.push({ file: file, filetype: filetype });
//       // this.uploadFiles(file, filetype);
//     } else {
//       filetype = 'documents';
//       filesArray.push(
//         {
//           file: file,
//           filetype: filetype
//         }
//         // 
//       );
//       // this.uploadFiles(file, filetype);
//     }
//   }
//   console.log(filesArray)

// }
// onFileChange(event) {
//   const files = event.target.files;
//   // const output = document.getElementById('output');
//   // output.innerHTML = ''; // Clear previous output

//   for (let i = 0; i < files.length; i++) {
//     const file = files[i];

//     // Check the file type if necessary
//     if (!file.type.match('text.*')) {
//       continue;
//     }

//     const reader = new FileReader();

//     reader.onload = (function (theFile) {
//       return function (e) {
//         // const div = document.createElement('div');
//         // div.innerHTML = `<strong>${theFile.name}</strong><br><pre>${e.target.result}</pre>`;
//         // output.appendChild(div);
//       };
//     })(file);

//     reader.readAsText(file);
//   }
// }

uploadFiles(files: File[] = []) {
  if (this.loadingSubject.value) {
    return;
  }

  this.loadingSubject.next(true);
  // for (let file of files) {
  //   console.log(file?.file.name);
  //   filesArr.push(
  //     { 
  //       name:file?.file?.name,
  //       lastModified:file?.file?.lastModified,
  //       webkitRelativePath:file?.file?.webkitRelativePath,
  //       size:file?.file?.size,
  //       lastModifiedDate:new Date(file?.file['lastModifiedDate']),
  //      }
  //   )
  // }
  // console.log(filesArr);
  // let req = { files: filesArr, reference_types: 'briefing_form' }
  // console.log(req);
  const formData = new FormData();
  // const req={
  //   files:...files,
  // }
  for (let file of files) {
    formData.append('myFile', file);
  }
  formData.append('reference_types', 'briefing_form');
  console.log(formData);
  this.dlService.multipleUploadDoc(formData).pipe(takeUntil(this.ngUnsubscribe), finalize(() => { this.loadingSubject.next(false) })).subscribe(data => {
    console.log(data);

    if (data['status'] == 200) {
      data['filedata'].forEach((file) => {
        console.log(file);
        this.pushFileData(file?.uploadedFile, file?.uploadedFile[0]?.file_mime_type)
        // this.openSnackbar(file.uploadedFile?.message);
        this.openSnackbar(data['message']);
      })
      sessionStorage.setItem('fileList', JSON.stringify(this.formDailyLog?.get('daily_log_uploads_document')?.value))
      // console.log(JSON.parse(sessionStorage.getItem('fileList')));
    }
    else this.openSnackbar(data['message']);

    // console.log(data);

    //   if (data['status'] == 200) {
    //     this.pushFileData(data['filedata'], type)
    //     this.openSnackbar(data['message']);
    //   } else this.openSnackbar(data['message']);
    // }, error => {
    //   // console.log(error);
  }
  )
}
getFormattedDate() {
  const now = new Date();

  // Extract parts of the date
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  // Format the date and time
  return `${year}${month}${day}_${hours}${minutes}${seconds}`;
}

// getFileName(baseName) {
//   const timestamp = this.getFormattedDate();
//   return `${baseName}_${timestamp}`;
// }
uploadImage(image) {
  this.loadingSubject.next(true);
  if (image) {
    let formData = new FormData();
    console.log(new Date);
    // const filename=this.getFileName('captured-image')
    const blob = this.convertBase64ToBlob(image, 'image/png');
    const file = this.createFileFromBlob(blob, `${this.getFormattedDate()}_captured.png`);
    console.log(file);
    formData.append('myFile', file);
    formData.append('reference_types', 'briefing_form');
    console.log(blob);
    console.log(formData);
    this.dlService.multipleUploadDoc(formData).pipe(takeUntil(this.ngUnsubscribe), finalize(() => { this.loadingSubject.next(false) })).subscribe(data => {
      console.log(data);
      if (data['status'] == 200) {
        data['filedata'].forEach((file) => {
          console.log(file);
          // this.pushFileData(file?.uploadedFile, file?.uploadedFile?.file_mime_type)
        this.pushFileData(file?.uploadedFile, file?.uploadedFile[0]?.file_mime_type)
          // this.openSnackbar(file.uploadedFile?.message);
          this.openSnackbar(data['message'])
        })
        this.loadingSubject.next(false);
        sessionStorage.setItem('fileList', JSON.stringify(this.formDailyLog?.get('daily_log_uploads_document')?.value))
      }
      else this.openSnackbar(data['message']);

      // console.log(data);

      //   if (data['status'] == 200) {
      //     this.pushFileData(data['filedata'], type)
      //     this.openSnackbar(data['message']);
      //   } else this.openSnackbar(data['message']);
      // }, error => {
      //   // console.log(error);
    }
    )
  }
}



pushFileData(data, type) {
  console.log(this.formDailyLog?.get('daily_log_uploads_document'));
  console.log(data);
  console.log(type);
  let control = this.formDailyLog?.get('daily_log_uploads_document') as FormArray;
  control?.push(this.fb.group({
    file_path: [data[0]?.file_path],
    fileName: [data[0]?.file_original_name],
    file_id: [data[0]?.file_id],
    daily_log_upload_type: [type],
  }));
  console.log(this.formDailyLog?.get('daily_log_uploads_document'));
  this.fileInput.nativeElement.value = '';

}

removeFile(index, type, file) {
  if (type == 'document') {
    let control = this.formDailyLog.get('daily_log_uploads_document') as FormArray;
    control.removeAt(index);
    // this.fil
  } else {
    let control = this.formDailyLog.get('daily_log_uploads') as FormArray;
    control.removeAt(index);
  }
  console.log(this.formDailyLog.get('daily_log_uploads_document')?.value);
  sessionStorage.setItem('fileList', JSON.stringify(this.formDailyLog.get('daily_log_uploads_document')?.value))
  console.log(file?.file_id);
  console.log(file);
  this.dlService.deleteFileById({
    file_id: file?.file_id,
    file_original_name: file?.fileName
  }).subscribe(res => console.log(res));
  // this.fileMngSrvc.deleteDocFromFile(file?.file_id).subscribe(res => console.log(res))
}

saveFormDailyLog() {
  if (this.loadingSubject.value) {
      return;
    }
    if(this.formDailyLog?.value?.date_related_exists===true && !this.formDailyLog?.value?.date_related) {
      this.openSnackbar('Select Date')
      return;
    
    }
    if(this.formDailyLog?.value?.date_related_exists===true && !this.selectedWeather) {
      this.openSnackbar('Please select weather conditions')
      return;
    }
  if (this.latitude && this.longitude) {
    this.formDailyLog.markAsTouched();
    if (!this.formDailyLog.invalid) {
        this.loadingSubject.next(true);
      let request = JSON.stringify(this.formDailyLog.value);
      request = JSON.parse(request);
      request['daily_log_uploads'] = request['daily_log_uploads'].concat(request['daily_log_uploads_document']);
      if(this.formDailyLog?.value?.date_related_exists) request['date_related']=this.formatDateToUTC(this.formDailyLog?.value?.date_related);
      else delete request['date_related']
      delete request['daily_log_uploads_document'];
      delete request['date_related_exists'];
      request['weather_location'] = {
        latitude: this.latitude,
        longitude: this.longitude,
      }
      const classifyFileType = (file) => {
        console.log(file);
        if ((file.daily_log_upload_type === 'image/jpeg') || (file.daily_log_upload_type === 'image/jpg') || (file.daily_log_upload_type === 'image/png')) {
          return 'photo';
        } else if ((file.daily_log_upload_type === 'video/mp4') || (file.daily_log_upload_type === 'video/quicktime')) {
          return 'video';
        } else {
          return 'documents';
        }
      };


      request['daily_log_uploads'] = request['daily_log_uploads'].map(file => {
        console.log(file);
        file.daily_log_upload_type = classifyFileType(file); // Set the type for payload
        return file;
      });

      request['project_id'] = this.projectId;
      // request['contractor_account_id'] = this.contractorId;
      request['show_to_contractor'] = this.showToContractor;
      request['show_to_customer'] = this.showToCustomer;
      request['contractors'] = JSON.parse(JSON.stringify(this.contractorList.filter(item => item.checked)));
      request['contractors'].forEach((dt) => {
        delete dt['checked'];
        delete dt['subcontractor_name']
      })
      request['user_id'] = this.user_id;
      if(this.formDailyLog?.value?.date_related_exists===true){
          request['weather_icon']=this.selectedWeatherIcon;
      }
      // console.log(request)
      this.dlService.saveDailyLog(request).subscribe(data => {
        console.log(data);
        if (data['status'] === 200 && data['message']) {
          sessionStorage.removeItem('fileList')
          this.openSnackbar(data['message']);
          this.back();
          // this.router.navigate(['/project/daily-logs', this.bid_ext_id])
        }
      }, error => {
        // Handle error
        console.error(error);
      });
    }
  }
  else {
    this.openSnackbar('Please allow location access and refresh to create a daily log!')
  }
}
//new code ends

openCaptureDialog() {
  const dialogRef = this.dialog.open(CaptureMediaComponent, {
    data: {
      animal: 'panda',
    },
  });
  dialogRef.componentInstance.captureImageEmitter.subscribe(image => {
    // console.log(res)
    this.uploadImage(image)
  });
}
convertBase64ToBlob(base64Url: string, contentType: string) {
  const byteCharacters = atob(base64Url.split(',')[1]);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
}
private createFileFromBlob(blob: Blob, fileName: string): File {
  return new File([blob], fileName, { type: blob.type });
}
downloadFile(file) {
  if (file?.file_path && file?.file_path !== '') {
    window.open(file.file_path, '_blank');
  }
}


openSnackbar(message: string) {
    this.snackbarService.open(message);
  }

  back() {
    this.router.navigate([`/dashboard/details/${this.projectId}/daily-logs`], { queryParams: { id: this.projectId } });
  }
  formatDateToUTC(date) {
    return new Date(Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds()
    )).toISOString();
  }
getIconUrl(icon): string {
    return `http://openweathermap.org/img/wn/${icon}@2x.png`
  }
  selectWeather(icon,index){
    this.selectedWeatherIndex=index;
    this.selectedWeather=icon?.weather;
    this.selectedWeatherIcon=icon?.icon;
    console.log(this.selectedWeatherIndex)
  }
}
